/** Every key that must be present in `integrationRegistry` once registration
 * has run, and the seal guard's source of truth.
 *
 * Deliberately a bare literal list with no imports: it keeps the registry's
 * *type* closed while its *population* becomes dynamic.
 */
// NOTE FOR HUMANS AND AGENTS ALIKE: keep keys lexically sorted
export const RegisteredIntegrationKeys = [
  "1password",
  "agentic",
  "app",
  "argocd",
  "auth0",
  "aws",
  "aws-midc",
  "aws-oidc",
  "aws-rds",
  "aws-sm",
  "azure",
  "azure-ad",
  "bundle",
  "clickhouse",
  "cloudflare",
  "custom",
  "databricks",
  "databricks-ai",
  "datadog-ai",
  "docker",
  "dynamodb-ai",
  "entra-id",
  "file-transfer",
  "gcloud",
  "gcp-cloudsql",
  "gcp-service-account",
  "gcp-sm",
  "gcp-wif",
  "github",
  "github-ai",
  "github-repositories",
  "gitlab-ai",
  "google-drive-ai",
  "grafana-cloud",
  "harbor",
  "identity-provider",
  "jira-ai",
  "k8s",
  "launchdarkly",
  "looker-ai",
  "miro-ai",
  "mongodb-atlas-ai",
  "mysql",
  "oci",
  "okta",
  "pagerduty-ai",
  "pg",
  "postgres",
  "rdp",
  "redshift-ai",
  "salesforce",
  "salesforce-ai",
  "self-hosted",
  "servicenow-ai",
  "snowflake",
  "snowflake-ai",
  "splunk-stack",
  "ssh",
  "tableau-ai",
  "tailscale",
  "workspace",
  "zscaler-private-access",
] as const;

export type RegisteredIntegrationKey =
  (typeof RegisteredIntegrationKeys)[number];
